module.exports = __webpack_public_path__ + "img/overview-screen.37008d32.svg";